import { Apikey, ApikeyFormData, CreateApikeyRequestData, UpdateApikeyRequestData } from '../types';

export function buildApikeyFormData(data?: Apikey): ApikeyFormData {
  return {
    id: data?.id,
    name: data?.name || '',
    description: data?.description || '',
    permissions: data?.permissions?.map(p => p.name) || [],
    token: data?.token,
  };
}

export function buildApikeyRequestData(
  data: ApikeyFormData,
): CreateApikeyRequestData | UpdateApikeyRequestData {
  return data.description
    ? {
        name: data.name,
        description: data.description,
        permissions: data.permissions,
      }
    : {
        name: data.name,
        permissions: data.permissions,
      };
}
